const domain = 'https://mingqoiupunun1919.top/';  //你的域名
export default {
  publicUrl:domain
}